//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PediatricTubeSize_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/PediatricTubeSize_info.vue